<template>
  <div class="row mb-3">
    <div class="col">
      <div class="card" v-if="uploadstatus">
        <div class="card-body">
          <div class="text-center">{{ 'Uploading' | translate }}...</div>
          <div
            class="progress mb-4"
            role="progressbar"
            aria-label="Upload progress"
            :aria-valuenow="uploadstatus"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              :style="`width: ${uploadstatus}%`"
            ></div>
          </div>
        </div>
      </div>
      <div class="card" v-else>
        <div class="card-body px-5">
          <button @click="showModal" class="btn btn-light text-start">
            {{ 'Add' | translate }}
          </button>
        </div>
      </div>


      <div ref="postCreateModal" class="modal fade" tabindex="-1" aria-labelledby="postCreate" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{ 'Add' | translate }} {{ 'post' | translate }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <input v-model="title" type="text" class="form-control" max="160" :placeholder="$t('Title')" />
              </div>
              <div class="mb-3">
                <textarea
                  v-model="body"
                  cols="30"
                  rows="10"
                  class="form-control"
                  :placeholder="$t('Content')"
                ></textarea>
              </div>
              <div class="mb-3" v-if="imagePreview">
                <img :src="imagePreview" alt="" class="img-fluid" />
              </div>
              <div class="mb-3" v-if="showImageUpload">
                <input
                  class="form-control"
                  type="file"
                  id="formFile"
                  @change="fileUpload"
                  accept="image/png, image/gif, image/jpeg"
                />
                <small class="text-danger" v-if="uploadError">{{ uploadError }}</small>
              </div>
              <div class="mb-3" v-if="showVideoUpload">
                <div>
                  <input
                    id="video-url"
                    name=""
                    type="text"
                    class="form-control"
                    v-model="video"
                    placeholder="Embed url (Vimeo, YouTube)"
                  />
                </div>
                <div class="mt-3">
                  <div v-if="!video_file_upload && !video_file">
                    <button @click="addVideo" class="btn btn-outline-secondary btn-sm">
                      {{ 'Choose file' | translate }}
                    </button>
                  </div>
                  <div v-if="video_file">
                    <div class="ratio ratio-16x9">
                      <video :src="fileUrl"></video>
                    </div>
                    <button @click="removeVideo" class="btn btn-link text-secondary btn-sm">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div>
                  <button class="btn btn-link btn-sm me-1" @click="toggleImageUpload" v-if="!showVideoUpload">
                    <i class="fas fa-times" v-if="showImageUpload"></i>
                    <i class="far fa-image" v-else></i>
                  </button>
                  <button class="btn btn-link btn-sm" @click="toggleVideoUpload" v-if="!showImageUpload">
                    <i class="fas fa-times" v-if="showVideoUpload"></i>
                    <i class="far fa-play-circle" v-else></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                {{ 'Cancel' | translate }}
              </button>
              <button type="button" :class="['btn', 'btn-primary', isValid ? '' : 'disabled']" @click="createPost">
                {{ 'Create' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ImageUpload from '~/components/ImageUpload'
import { Upload } from 'tus-js-client'

export default {
  components: {
    ImageUpload,
  },
  props: ['topic'],
  data: () => ({
    uploadstatus: 0,
    upload: null,
    title: '',
    body: '',
    imagePreview: null,
    image: null,
    showImageUpload: false,
    video: null,
    video_file_upload: 0,
    video_file: null,
    showVideoUpload: false,
    modal: null,
    files: null,
    file: null,
    uploadError: null,
  }),
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.postCreateModal)
  },
  computed: {
    fileUrl() {
      if (!this.video_file) {
        return null
      }
      return URL.createObjectURL(this.video_file)
    },

    isValid() {
      if (this.title.length < 5 || this.title.length > 159) {
        return false
      }

      if (this.body.length < 5) {
        return false
      }

      return true
    },
  },
  methods: {
    initiateUpload({ data }) {
      if (data.videoUpload) {
        this.videoUpload = data.videoUpload
        return this.initiateTusUpload(data.videoUpload, data)
      }
      return data
    },
    initiateTusUpload(videoUpload, data) {
      this.uploadstatus = 1


      return new Promise((resolve) => {
        this.upload = new Upload(this.video_file, {
          endpoint: videoUpload.endpoint,
          retryDelays: [0, 3000, 5000, 10000, 20000],
          headers: {
            AuthorizationSignature: videoUpload.AuthorizationSignature,
            AuthorizationExpire: videoUpload.AuthorizationExpire,
            VideoId: videoUpload.VideoId,
            LibraryId: videoUpload.LibraryId,
          },
          metadata: {
            filetype: this.video_file.type,
            title: videoUpload.title,
          },
          onError: (error) => {
            iziToast.error({
              title: 'Error',
              message: this.$t('Something went wrong'),
              position: 'bottomLeft',
            })
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            this.uploadstatus = Math.ceil((bytesUploaded / bytesTotal) * 100)
            console.log(bytesUploaded)
          },
          onSuccess: () => {
            this.uploading = false
            this.uploadFinished = true
            this.transcoding = true
            this.uploadstatus = 0
            this.file = null
            this.video_file = null
            this.video_file_upload = 0

            iziToast.success({
              title: 'OK',
              message: this.$t('Saved'),
              position: 'bottomLeft',
            })
            resolve(data)
          },
        })

        this.upload.findPreviousUploads().then((previousUploads) => {
          if (previousUploads.length) {
            this.upload.resumeFromPreviousUpload(previousUploads[0])
          }

          this.uploading = true
          this.upload.start()
          this.hideModal()
        })
      })
    },
    addVideo() {
      const fileInput = document.createElement('input')
      fileInput.setAttribute('type', 'file')
      fileInput.setAttribute('accept', 'video/*')
      fileInput.click()
      fileInput.addEventListener('change', (e) => {
        this.video_file = e.target.files[0]
        this.video_file_upload = 1
      })
    },
    removeVideo() {
      this.video_file = null
      this.video_file_upload = 0
    },
    fileUpload(e) {
      let files = e.target.files
      let file = files[0]
      let size = file.size
      let allowedSize = 600000
      if (size > allowedSize) {
        return this.displayUploadError()
      }
      let url = URL.createObjectURL(file)
      this.imagePreview = url
      this.file = file
    },
    displayUploadError() {
      this.uploadError = this.$t('validation.max.file', { attribute: 'file', max: '600' })
      setTimeout(() => {
        this.uploadError = null
      }, 3000)
    },
    showModal() {
      this.modal.show()
    },
    hideModal() {
      this.modal.hide()
    },
    toggleImageUpload() {
      this.showImageUpload = !this.showImageUpload
      if (!this.showImageUpload) {
        this.imagePreview = null
        this.image = null
        this.file = null
      }
    },
    toggleVideoUpload() {
      this.showVideoUpload = !this.showVideoUpload
    },
    storeImage(file) {
      this.image = file
    },
    deleteImage() {
      this.image = null
    },
    clean() {
      this.title = ''
      this.body = ''
      this.image = null
      this.imagePrevview = null
      this.file = null
      this.video_file = null
      this.video_file_upload = 0
      this.showImageUpload = false
      this.showVideoUpload = false
    },
    createPost() {
      let formData = new FormData()

      formData.append('title', this.title)
      formData.append('body', this.body)
      if (this.image) {
        formData.append('image', this.image)
      }
      if (this.file) {
        formData.append('file', this.file)
      }
      if (this.video) {
        formData.append('video', this.video)
      }
      if (this.video_file_upload) {
        formData.append('video_file_upload', this.video_file_upload)
      }

      axios
        .post(`/json/community/topics/${this.topic.id}/post/create`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(this.initiateUpload)
        .then((data) => {
          this.$emit('postCreated', data.post)
          this.hideModal()
          this.clean()
        })
    },
  },
}
</script>
